const getCheckedInputs = (element)=>Array.from(element.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked'));
export const readIsChecked = (element)=>getCheckedInputs(element).length > 0;
export const readCheckedValues = (element)=>getCheckedInputs(element).map((input)=>input.value);
export const readCheckedValue = (element)=>getCheckedInputs(element)[0]?.value;
export const readCheckedRating = (element)=>{
    const rating = readCheckedValue(element);
    return rating ? Number(rating) : undefined;
};

//# sourceMappingURL=prehydration-readers.js.map